import React, { useEffect, useRef } from 'react'
import className from 'classnames/bind'

import style from './MyhouseAttachmentTooltip.module.scss'

import IconClose15x15 from '@Ui/images/myhouse/IconClose15x15.svg'

const cx = className.bind(style)

type Props = {
  isShow: boolean
  setIsShow: (isShow: boolean) => void
  isCenter?: boolean
}

const MyhouseAttachmentTooltip: React.FC<Props> = ({ isShow, setIsShow, isCenter = false }: Props) => {
  const tooltipLayer = useRef(null)
  const tooltipButton = useRef(null)

  useEffect(() => {
    if (isShow) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isShow])

  const handleTooltipClose = () => {
    setIsShow(false)
    document.removeEventListener('mousedown', handleClickOutside)
  }

  const handleClickOutside = (event: any) => {
    let ele = event.target
    while (true) {
      if (ele === tooltipLayer.current || ele === tooltipButton.current) {
        break
      } else if (ele.id === 'wrap' || ele.nodeName.toUpperCase() === 'BODY') {
        handleTooltipClose()
        break
      }
      ele = ele.parentNode
    }
  }

  return (
    <div ref={tooltipLayer} className={cx('tooltip', isShow && 'is_show', isCenter && 'is_center')}>
      <strong className={cx('title')}>파일첨부 가이드라인</strong>
      <p className={cx('text')}>입주민 인증을 위해 제출한 사진 또는 파일에서 확인하는 정보는 아래의 항목입니다.</p>
      <div className={cx('description')}>
        <span className={cx('item')}>우리집 주소지 동호수 포함</span>
      </div>
      <p className={cx('text')}>
        개인정보 보호를 위해 위의 정보를 제외한 다음의 개인정보는 삭제하고 서류를 등록해 주세요. 필요한 정보 외의 개인정보가 노출된 채로 접수되는 경우 검수가 반려됩니다.
      </p>
      <div className={cx('description')}>
        <span className={cx('item')}>주민등록번호 뒤 7자리</span>
        <span className={cx('item')}>이름, 개인의 전화번호 및 이메일 주소, 우편/택배물 발송자의 주소지</span>
        <span className={cx('item')}>개인의 계좌번호 (관리비 고지서의 임시 계좌번호는 허용함)</span>
        <span className={cx('item')}>주문품목</span>
      </div>
      <p className={cx('text')}>파일은 5MB 이내로 업로드가 가능하며 아래 형식만 허용합니다. JPG, JPEG, PNG, BMP</p>
      <button ref={tooltipButton} type="button" className={cx('button_close')} onClick={handleTooltipClose}>
        <IconClose15x15 />
        <span className="blind">닫기</span>
      </button>
    </div>
  )
}

export default MyhouseAttachmentTooltip
